<template>
  <div id="app">
    <component :is="layoutComponent" />
    <Alert />
    <Loading />
  </div>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue';
import { useRoute } from 'vue-router';

import Alert from '@/components/Alert.vue';
import Loading from '@/components/Loading.vue';

import DefaultLayout from '@/layouts/default.vue';
import AuthLayout from '@/layouts/auth.vue';

export default defineComponent({
  name: 'App',
  components: {
    Alert,
    Loading,
    DefaultLayout,
    AuthLayout
  },
  setup() {
    const route = useRoute();

    const layoutComponent = computed(() => {
      const layout = (route.meta as any)?.layout;
      return layout === 'auth' ? 'AuthLayout' : 'DefaultLayout';
    });

    return { layoutComponent };
  }
});
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css?family=Roboto:300,400,500,700&display=swap');
</style>
